package com.devsusana.portfolio.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.icons.MoonIcon
import com.varabyte.kobweb.silk.components.icons.SunIcon
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.px

/**
 * Interactive button to toggle between Light and Dark color modes.
 */
@Composable
fun ThemeToggle(modifier: Modifier = Modifier) {
    var colorMode by ColorMode.currentState
    Button(
        onClick = {
            colorMode = if (colorMode == ColorMode.DARK) ColorMode.LIGHT else ColorMode.DARK
        },
        modifier = modifier
            .borderRadius(8.px)
            .padding(8.px)
    ) {
        if (colorMode == ColorMode.DARK) {
            SunIcon()
        } else {
            MoonIcon()
        }
    }
}
